import { Component, OnDestroy, OnInit, } from '@angular/core';

@Component({
  selector: 'starter',
  template: require('./starter.template.html')
})
export class StarterViewComponent implements OnDestroy, OnInit  {

public nav:any;

public constructor() {
  this.nav = document.querySelector('nav.navbar');
}

public ngOnInit():any {
  this.nav.className += " white-bg";
}


public ngOnDestroy():any {
  this.nav.classList.remove("white-bg");
}

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/customerviews/starterview.component.ts